var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t0rmhq17xb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.171
  })), /*#__PURE__*/React.createElement("rect", {
    id: "1jqugkejza",
    width: 78,
    height: 78,
    x: 0,
    y: 0,
    rx: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-438.000000, -207.000000) translate(438.000000, 207.000000) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#B31B34",
    xlinkHref: "#1jqugkejza"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#t0rmhq17xb)",
    xlinkHref: "#1jqugkejza"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.337 0h5.22v11.598c0 2.13-.559 3.866-1.676 5.206-.642.771-1.458 1.386-2.449 1.841-.99.456-2.007.685-3.05.685-2.074 0-3.823-.698-5.247-2.094C.712 15.84 0 14.128 0 12.1c0-1.963.707-3.661 2.121-5.094 1.415-1.433 3.09-2.15 5.025-2.15.306 0 .772.029 1.395.085v5.75c-.428-.336-.856-.503-1.284-.503-.54 0-1.002.198-1.388.593-.387.396-.58.873-.58 1.43 0 .54.2 1.003.6 1.39.4.386.88.578 1.438.578 1.34 0 2.01-.925 2.01-2.777V0zM32.81 13.642c-.82.82-2.147.82-2.967 0-.819-.819-.819-2.147 0-2.967l1.484-1.483 1.483 1.483c.82.82.82 2.148 0 2.967m3.722-6.67c-1.409-1.42-3.1-2.13-5.073-2.13-2.102 0-3.87.696-5.303 2.087-1.433 1.391-2.149 3.106-2.149 5.143 0 2 .716 3.71 2.149 5.129 1.433 1.419 3.159 2.128 5.178 2.128s3.742-.707 5.17-2.121c1.429-1.414 2.143-3.126 2.143-5.136 0-1.982-.705-3.682-2.115-5.1",
    transform: "translate(-438.000000, -207.000000) translate(438.000000, 207.000000) translate(0.000000, 0.000000) translate(12.466667, 27.400000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.41 6.41c.235-.228.48-.437.731-.63-1.582-.726-3.593-.926-4.65-.937-1.833-.02-3.299.598-4.396 1.793-1.098 1.196-1.647 2.798-1.647 4.808v7.606h5.22v-6.6c0-1.452.479-2.083 1.423-2.178.312-.032.715.022 1.1.193.297-1.55 1.04-2.91 2.22-4.055M44.593 24.2h-5.22V12.589c0-2.131.559-3.867 1.675-5.206.642-.772 1.459-1.386 2.45-1.842.99-.456 2.007-.684 3.049-.684 2.075 0 3.824.697 5.247 2.093 1.424 1.396 2.136 3.108 2.136 5.136 0 1.973-.707 3.675-2.122 5.108-1.414 1.433-3.088 2.15-5.024 2.15-.316 0-.781-.034-1.396-.098v-5.75c.429.344.856.516 1.285.516.54 0 1.002-.2 1.388-.6.386-.4.58-.874.58-1.424 0-.549-.2-1.016-.6-1.402-.4-.386-.88-.58-1.438-.58-1.34 0-2.01.926-2.01 2.778V24.2z",
    transform: "translate(-438.000000, -207.000000) translate(438.000000, 207.000000) translate(0.000000, 0.000000) translate(12.466667, 27.400000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropAppIcon);
export default __webpack_public_path__ + "static/media/drop-app-icon.097651ea.svg";
export { ForwardRef as ReactComponent };